import React from 'react';

import { trans } from '../../../../../localization/index';
import Modal, {
  ModalAction,
  ModalBody,
  ModalButton,
  ModalHeader,
} from '../../../../../components/Modal/Modal';
import RejectOrderDishTable from './components/RejectOrderDishTable';
import RejectOrderDishEditTable from './components/RejectOrderDishEditTable';
import { EnumRejectOrderReason } from '../../../../../constants/enum';
import { isEmptyObject } from '../../../../../utils/utils';

function DishView({
  itemDetail,
  setEditDishOutOfStock,
  handleRejectOrder,
  outOfStockOrder,
  priceUpdateOrder,
  handleUpdateOrder,
}) {
  const {
    toppings: listToppingOutOfStock = [],
    dishes: listDishOutOfStock = [],
  } = outOfStockOrder;
  const {
    dishes: listDishPrice = [],
    toppings: listToppingPrice = [],
  } = priceUpdateOrder;
  const isUpdate =
    !isEmptyObject(listDishPrice) ||
    !isEmptyObject(listToppingPrice) ||
    !isEmptyObject(listDishOutOfStock) ||
    !isEmptyObject(listToppingOutOfStock);
  return (
    <div>
      <ModalHeader>{trans('mod_what_you_need_to_fix')}</ModalHeader>
      <ModalBody>
        <RejectOrderDishTable
          itemDetail={itemDetail}
          setEditDishOutOfStock={setEditDishOutOfStock}
          outOfStockOrder={outOfStockOrder}
          priceUpdateOrder={priceUpdateOrder}
        />
      </ModalBody>
      <ModalAction>
        {isUpdate && (
          <ModalButton onClick={() => handleUpdateOrder()}>
            {trans('mod_edited')}
          </ModalButton>
        )}
        <ModalButton
          type="cancel"
          onClick={() =>
            handleRejectOrder(EnumRejectOrderReason.CHOOSE_OPTION.id)
          }
        >
          {trans('mod_go_back')}
        </ModalButton>
      </ModalAction>
    </div>
  );
}

function DishEdit({
  itemDetail,
  setEditDishOutOfStock,
  itemDish,
  outOfStockOrder,
  priceUpdateOrder,
  handleOpenOutOfStockModal,
  handleChangePriceOrder,
}) {
  return (
    <div>
      <ModalHeader>{trans('mod_what_wrong_in_dish')}</ModalHeader>
      <ModalBody>
        <RejectOrderDishEditTable
          itemDetail={itemDetail}
          itemDish={itemDish}
          outOfStockOrder={outOfStockOrder}
          handleOpenOutOfStockModal={handleOpenOutOfStockModal}
          handleChangePriceOrder={handleChangePriceOrder}
          priceUpdateOrder={priceUpdateOrder}
        />
      </ModalBody>
      <ModalAction>
        <ModalButton onClick={() => setEditDishOutOfStock({})}>
          {trans('common_yes')}
        </ModalButton>
      </ModalAction>
    </div>
  );
}

function RejectOrderDishModal({
  isOpenDialog,
  itemDetail,
  handleRejectOrder,
  setEditDishOutOfStock,
  itemDish,
  outOfStockOrder,
  handleOpenOutOfStockModal,
  handleChangePriceOrder,
  priceUpdateOrder,
  handleUpdateOrder,
}) {
  const isShowDish = !isEmptyObject(itemDish);
  return (
    <Modal isOpen={isOpenDialog} width="800px" className="reject-order-dish">
      {!isShowDish ? (
        <DishView
          itemDetail={itemDetail}
          setEditDishOutOfStock={setEditDishOutOfStock}
          handleRejectOrder={handleRejectOrder}
          outOfStockOrder={outOfStockOrder}
          priceUpdateOrder={priceUpdateOrder}
          handleUpdateOrder={handleUpdateOrder}
        />
      ) : (
        <DishEdit
          itemDetail={itemDetail}
          setEditDishOutOfStock={setEditDishOutOfStock}
          itemDish={itemDish}
          outOfStockOrder={outOfStockOrder}
          priceUpdateOrder={priceUpdateOrder}
          handleOpenOutOfStockModal={handleOpenOutOfStockModal}
          handleChangePriceOrder={handleChangePriceOrder}
        />
      )}
    </Modal>
  );
}

export default RejectOrderDishModal;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/RejectOrder/RejectOrderDishModal.jsx